import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Carousel from "./features/carousel/Carousel";
import FineArts from "./pages/fineArts/FineArts"; // Ensure you created this file
import ScrollToTop from "./components/ScrollToTop"; // Highly recommended
import { ACADEMY_SLIDES } from "./data/slides";
import CourseDetails from "./pages/fineArts/courseDetails/CourseDetails";
import SummerPage from "./pages/summerCamp/SummerPage";
import Gallery from "./pages/Gallery/Gallery";
import FacultyGallery from "./pages/Gallery/FacultyGallery";
import {
  FACULTY_IMAGES,
  STUDENT_IMAGES,
} from "./data/galleryData";
import "./styles/global.css";
import FacultyPage from "./pages/faculty/FacultyPage";
import Features from "./features/Features";
import AboutPage from "./pages/About/About";
import SpringCamp from "./pages/springCamp/SpringCamp";
import Footer from "./components/Footer/Footer";
import VideoGallery from "./pages/videoGallery/VideoGallery";
import DanceGallery from "./pages/dance/DanceGallery";
import DancePhotosGallery from "./pages/dance/DancePhotosGallery";
import Success from "./pages/stripe/Success";
import Cancel from "./pages/stripe/Cancel";
import CheckInInterface from "./pages/checkin/CheckInInterface";
import FoodCheckoutInterface from "./pages/food-checkout/FoodCheckoutInterface";

// We create a Home component for the landing page content
const Home = () => (
  <>
    <section id="home">
      <Carousel slides={ACADEMY_SLIDES} autoPlay={true} interval={6000} />
    </section>

    {/* Enhanced About Section */}
    <section id="about" style={{ padding: "100px 20px", background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)" }}>
      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <h2
            style={{
              fontFamily: "Playfair Display, serif",
              fontSize: "3.5rem",
              textAlign: "center",
              color: "#1a1a1a",
              marginBottom: "25px",
              fontWeight: 700,
              letterSpacing: "-0.02em",
            }}
          >
            Where Passion Meets<br /><span style={{ color: "#ff8c00" }}>Practice</span>
          </h2>
          <div style={{
            height: "4px",
            width: "80px",
            background: "linear-gradient(90deg, #ff8c00 0%, #ffa500 100%)",
            margin: "0 auto 30px",
            borderRadius: "2px"
          }}></div>
        </div>

        <p
          style={{
            maxWidth: "700px",
            margin: "0 auto 50px",
            textAlign: "center",
            lineHeight: "1.9",
            fontFamily: "'Inter', sans-serif",
            fontSize: "1.1rem",
            fontWeight: 400,
            color: "#444",
          }}
        >
          Nupur Creations Academy is dedicated to nurturing the next generation of performers and visual artists through rigorous training, expert guidance, and creative freedom. Our mission is to inspire, educate, and empower artists of all ages.
        </p>

        <div style={{ display: "flex", gap: "20px", justifyContent: "center", flexWrap: "wrap", marginTop: "50px" }}>
          <a 
            href="/fine-arts" 
            style={{
              display: "inline-block",
              padding: "14px 40px",
              background: "#ff8c00",
              color: "white",
              textDecoration: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: 600,
              transition: "all 0.3s ease",
              border: "2px solid #ff8c00",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#e67e00";
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 10px 25px rgba(255, 140, 0, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#ff8c00";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            Explore Fine Arts
          </a>
          <a 
            href="/dance" 
            style={{
              display: "inline-block",
              padding: "14px 40px",
              background: "transparent",
              color: "#ff8c00",
              textDecoration: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: 600,
              transition: "all 0.3s ease",
              border: "2px solid #ff8c00",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#ff8c00";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 10px 25px rgba(255, 140, 0, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.color = "#ff8c00";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            Explore Dance
          </a>
          <button 
            style={{
              display: "inline-block",
              padding: "14px 40px",
              background: "transparent",
              color: "#999",
              border: "2px solid #999",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: 600,
              transition: "all 0.3s ease",
              cursor: "default",
              textDecoration: "none",
              fontFamily: "inherit"
            }}
          >
            Explore Music
          </button>
        </div>
      </div>
    </section>

    {/* Statistics/Highlights Section */}
    <section style={{ padding: "80px 20px", background: "#1a1a1a", color: "white" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "50px",
          textAlign: "center"
        }}>
          <div>
            <div style={{ fontSize: "3rem", fontWeight: 700, color: "#ff8c00", marginBottom: "10px" }}>200+</div>
            <p style={{ fontSize: "1.1rem", color: "#ccc" }}>Happy Students</p>
          </div>
          <div>
            <div style={{ fontSize: "3rem", fontWeight: 700, color: "#ff8c00", marginBottom: "10px" }}>15+</div>
            <p style={{ fontSize: "1.1rem", color: "#ccc" }}>Years of Excellence</p>
          </div>
          <div>
            <div style={{ fontSize: "3rem", fontWeight: 700, color: "#ff8c00", marginBottom: "10px" }}>10+</div>
            <p style={{ fontSize: "1.1rem", color: "#ccc" }}>Courses Offered</p>
          </div>
        </div>
      </div>
    </section>

    {/* Benefits Grid Section */}
    <section style={{ padding: "80px 20px", background: "#ffffff" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <h2 style={{
            fontFamily: "Playfair Display, serif",
            fontSize: "2.8rem",
            color: "#1a1a1a",
            marginBottom: "20px",
            fontWeight: 700,
          }}>
            What Sets Us <span style={{ color: "#ff8c00" }}>Apart</span>
          </h2>
          <div style={{
            height: "4px",
            width: "80px",
            background: "linear-gradient(90deg, #ff8c00 0%, #ffa500 100%)",
            margin: "0 auto",
            borderRadius: "2px"
          }}></div>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "40px"
        }}>
          {/* Benefit 1 */}
          <div style={{
            padding: "40px 30px",
            background: "#f8f9fa",
            borderRadius: "12px",
            border: "1px solid #e0e0e0",
            transition: "all 0.3s ease",
            cursor: "pointer",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-8px)";
            e.currentTarget.style.boxShadow = "0 15px 40px rgba(255, 140, 0, 0.15)";
            e.currentTarget.style.borderColor = "#ff8c00";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
            e.currentTarget.style.borderColor = "#e0e0e0";
          }}>
            <div style={{
              fontSize: "2.5rem",
              marginBottom: "15px"
            }}>👥</div>
            <h3 style={{
              fontSize: "1.3rem",
              color: "#1a1a1a",
              marginBottom: "12px",
              fontWeight: 700
            }}>1-on-1 Feedback</h3>
            <p style={{
              color: "#555",
              fontSize: "0.95rem",
              lineHeight: "1.6"
            }}>
              Personalized guidance from expert instructors tailored to your unique learning style and pace.
            </p>
          </div>

          {/* Benefit 2 */}
          <div style={{
            padding: "40px 30px",
            background: "#f8f9fa",
            borderRadius: "12px",
            border: "1px solid #e0e0e0",
            transition: "all 0.3s ease",
            cursor: "pointer",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-8px)";
            e.currentTarget.style.boxShadow = "0 15px 40px rgba(255, 140, 0, 0.15)";
            e.currentTarget.style.borderColor = "#ff8c00";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
            e.currentTarget.style.borderColor = "#e0e0e0";
          }}>
            <div style={{
              fontSize: "2.5rem",
              marginBottom: "15px"
            }}>🎭</div>
            <h3 style={{
              fontSize: "1.3rem",
              color: "#1a1a1a",
              marginBottom: "12px",
              fontWeight: 700
            }}>Performance Opportunities</h3>
            <p style={{
              color: "#555",
              fontSize: "0.95rem",
              lineHeight: "1.6"
            }}>
              Showcase your talent in exclusive recitals, competitions, and community events throughout the year.
            </p>
          </div>

          {/* Benefit 3 */}
          <div style={{
            padding: "40px 30px",
            background: "#f8f9fa",
            borderRadius: "12px",
            border: "1px solid #e0e0e0",
            transition: "all 0.3s ease",
            cursor: "pointer",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-8px)";
            e.currentTarget.style.boxShadow = "0 15px 40px rgba(255, 140, 0, 0.15)";
            e.currentTarget.style.borderColor = "#ff8c00";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
            e.currentTarget.style.borderColor = "#e0e0e0";
          }}>
            <div style={{
              fontSize: "2.5rem",
              marginBottom: "15px"
            }}>📚</div>
            <h3 style={{
              fontSize: "1.3rem",
              color: "#1a1a1a",
              marginBottom: "12px",
              fontWeight: 700
            }}>Structured Curriculum</h3>
            <p style={{
              color: "#555",
              fontSize: "0.95rem",
              lineHeight: "1.6"
            }}>
              Comprehensive, well-designed courses that progress from basics to advanced techniques with certified levels.
            </p>
          </div>

          {/* Benefit 4 */}
          <div style={{
            padding: "40px 30px",
            background: "#f8f9fa",
            borderRadius: "12px",
            border: "1px solid #e0e0e0",
            transition: "all 0.3s ease",
            cursor: "pointer",
            textAlign: "center"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-8px)";
            e.currentTarget.style.boxShadow = "0 15px 40px rgba(255, 140, 0, 0.15)";
            e.currentTarget.style.borderColor = "#ff8c00";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
            e.currentTarget.style.borderColor = "#e0e0e0";
          }}>
            <div style={{
              fontSize: "2.5rem",
              marginBottom: "15px"
            }}>🎨</div>
            <h3 style={{
              fontSize: "1.3rem",
              color: "#1a1a1a",
              marginBottom: "12px",
              fontWeight: 700
            }}>Creative Community</h3>
            <p style={{
              color: "#555",
              fontSize: "0.95rem",
              lineHeight: "1.6"
            }}>
              Join a supportive network of artists and performers who inspire and motivate each other daily.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section id="fineArts">
      <VideoGallery />
    </section>
    <section id="whyNupurCreations">
      <Features />
    </section>
  </>
);

const App = () => {
  return (
    <Router>
      <ScrollToTop /> {/* Ensures page starts at top on navigation */}
      <main className="app-container">
        <Navbar />
        <Routes>
          {/* Main Landing Page */}
          <Route path="/" element={<Home />} />
          {/* Fine Arts Page */}
          <Route path="/fine-arts" element={<FineArts />} />
          <Route path="/course/:courseId" element={<CourseDetails />} />
          <Route path="/summer-camp" element={<SummerPage />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route
            path="/facultyArt"
            element={<FacultyGallery facultyData={FACULTY_IMAGES} />}
          />
          <Route
            path="/studentArt"
            element={
              <Gallery title="Student Masterpieces" images={STUDENT_IMAGES} />
            }
          />
          <Route path="/faculty" element={<FacultyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/spring-camp" element={<SpringCamp />} />
          <Route path="/event2026" element={<Navigate to="/" replace />} />
          <Route path="/buy-tickets" element={<Navigate to="/" replace />} />
          <Route path="/dance" element={<DanceGallery />} />
          <Route path="/dance-gallery" element={<DancePhotosGallery />} />
          <Route path="/checkin" element={<CheckInInterface />} />
          <Route path="/food-checkout" element={<FoodCheckoutInterface />} />
        </Routes>
        <Footer />
      </main>
    </Router>
  );
};

export default App;
